export const publisherReportsRequestTypes = {
  //applications: 'apps3', //apps
  applications: 'apps4',
  applications_placements: 'apps4', //apps + placements
  date: 'Date2', //date
  //country: 'Country2', //Country
  country: 'Country4',
  country_placements: 'Country4', // country + placements
  advertiser: 'advertiser5', // advertiser
  //placement: 'Placement1', //placement
  placement: 'placement_country',
  placement_country: 'placement_country', //country + placements
};

export const colsWidth = {
  apps: '433px',
  impressions: '165px',
  clicks: '108px',
  installs: '116px',
  earning: '117px',
  ctr: '118px',
  //cr: '',
  ecpm: '118px',
};

export const reportTableColsOrder = ['Impressions', 'Clicks', 'Installs', 'CTR', 'Earning', 'eCPM'];

export const reportUniqueFieldsList = {
  applications: 'pba_number',
  applications_placements: 'pba_number',
  date: 'dateUnix',
  country: 'country_code',
  country_placements: 'country_code',
  advertiser: 'adveriser_id',
  // placement: 'pba_number',
  placement: 'placement_id',
  placement_country: 'country_code',
};
